import { Box, BoxProps, Container } from '@chakra-ui/react'
import DiscoverSsmSlider from './DiscoverSsmSlider'
import { MotionBox, MotionText } from '@ui'
import { fadeIn } from '@lib/motion'
import { useInViewMotion } from '@lib/hooks'
import { IDiscoverSsmCard } from '@interfaces'

interface IDiscoverSsm {
  stickyId?: string
  containerProps?: BoxProps
  sliderCollection: IDiscoverSsmCard[]
  subTitle: string
  title: string
  description: string
}

const DiscoverSsm = ({
  stickyId = 'discover-ssm',
  containerProps,
  sliderCollection,
  subTitle,
  title,
  description,
}: IDiscoverSsm) => {
  const { controls, ref } = useInViewMotion(true)

  return (
    <Box
      id={stickyId}
      as="section"
      pt={{ base: 'padding.primary2', lg: 'padding.primary4' }}
      pb={{ base: '0', lg: 'padding.primary4' }}
      {...containerProps}
    >
      <MotionBox
        ref={ref}
        initial="hidden"
        animate={controls}
        variants={fadeIn.animationContainer}
      >
        <Container>
          <Box maxW="610px">
            <MotionText
              variants={fadeIn.up}
              fontSize={{ base: '2xl', lg: '3xl' }}
              color="red.primary"
              as="h3"
              mb={{ base: 1, lg: '0' }}
            >
              {subTitle}
            </MotionText>
            <MotionText
            variants={fadeIn.up}
            fontSize={{ base: '4xl', lg: '114px' }}
            color="rgba(178, 176, 171, 0.2)"
            fontFamily="heading"
            lineHeight="normal"
            as="h2"
            mb={{ base: 1, lg: '6px' }}
            >
              {title}
            </MotionText>
            <MotionText
              variants={fadeIn.up}
              fontSize={{ base: 'sm', lg: 'md' }}
              color="black.primary3"
              fontWeight="light"
            >
              {description}
            </MotionText>
          </Box>
        </Container>
        <DiscoverSsmSlider sliderCollection={sliderCollection} />
      </MotionBox>
    </Box>
  )
}

export default DiscoverSsm